import { useCallback, useContext, useState } from 'react'

import './headerMenu.css'
import './buttons/Icon.css'
import '../styles/global.css'
import { ArrowBackButton } from './buttons/arrowBackButton'
import { LanguageButton } from './buttons/languageButton'
import { FileButton } from './buttons/fileButton'
import { ProjectTitle } from './projectTitle'
import { LinkageButton } from './linkage/linkageButton'
import { DownloadButton } from './buttons/downloadButton'
import { ShareButton } from './buttons/shareButton'
import { useProject } from './project/hook'
import { RemixButton } from './buttons/remixButton'
import { HowToPlayButton } from './buttons/howToPlayButton'
import { DigitaneLogoButton } from './buttons/digitaneLogoButton'
import { UserContext } from './user/provider'

export const Separator = () => <div className="icon-border header-separator" />

interface HeaderMenuProps {
  type: 'editor' | 'list' | 'error'
  onTriggerDownloadTutorial?: () => void
  onDownloadButtonClick?: () => void
  onDownloadButtonFailed?: () => void
}

function HeaderMenu({
  type,
  onTriggerDownloadTutorial,
  onDownloadButtonClick,
  onDownloadButtonFailed,
}: HeaderMenuProps) {
  const { canEdit } = useProject()
  const { isOnlineUser } = useContext(UserContext)
  const [openMenu, setOpenMenu] = useState('')
  const editorPage = type === 'editor'
  const listPage = type === 'list'

  const handleToggleMenu = useCallback((menuName: string) => {
    setOpenMenu((prev) => (prev === menuName ? '' : menuName))
  }, [])

  return (
    // Setting the height here is necessary for the Blockly div to be sized correctly.
    <div className="header-menu" style={{ height: '52px' }}>
      <div className="header-menu-group" style={{ flex: '1 1 auto' }}>
        {isOnlineUser ?
          <ArrowBackButton />
        : <DigitaneLogoButton />}
        {(editorPage || listPage) && (
          <LanguageButton
            openMenu={openMenu}
            onToggleMenu={handleToggleMenu}
            buttonBorder={editorPage && canEdit}
          />
        )}
        {editorPage && (
          <>
            {canEdit && (
              <FileButton
                openMenu={openMenu}
                onToggleMenu={handleToggleMenu}
                buttonBorder={false}
              />
            )}
            <ProjectTitle />
            {canEdit && <div id="blockly-toolbar" />}
          </>
        )}
      </div>
      <div className="header-menu-group">
        {editorPage && (
          <>
            {/* おためしプレイの 実行/停止/リセットはプレビュー領域内（左下）へ移設した。
                ここではヘッダーには配置しない。 */}
            {canEdit ?
              <ShareButton />
            : <>
                <RemixButton />
                <Separator />
                <HowToPlayButton />
              </>
            }
            <DownloadButton
              onDownloadClick={onDownloadButtonClick}
              onDownloadFailed={onDownloadButtonFailed}
            />
            {canEdit && (
              <LinkageButton
                onTriggerDownloadTutorial={onTriggerDownloadTutorial}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default HeaderMenu
